import styled from "@emotion/styled";

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
`